import { render, staticRenderFns } from "./MenuContextualTablaAcuerdosComerciales.vue?vue&type=template&id=51e1cdcc"
import script from "./MenuContextualTablaAcuerdosComerciales.vue?vue&type=script&lang=js"
export * from "./MenuContextualTablaAcuerdosComerciales.vue?vue&type=script&lang=js"
import style0 from "./MenuContextualTablaAcuerdosComerciales.vue?vue&type=style&index=0&id=51e1cdcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemContent,VMenu})
